enum View {
  ByDate = 'By Date',
  BySprint = 'By Sprint',
}

export { View };
